import { render, staticRenderFns } from "./M-Sticker.vue?vue&type=template&id=de5b6954&lang=pug&"
import script from "./M-Sticker.vue?vue&type=script&lang=js&"
export * from "./M-Sticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports